import React, { useState, useMemo } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { Grid } from "@mui/material";
import OZInput from "../../../components/admin/common/OZInput";
import OZDialog from "../../../components/admin/common/OZDialog";
import { showErrorNotification, showSuccessNotification, showWarningNotification } from "../../../components/admin/common/NotiService";
import { ADMIN_FORM_MODES } from "../../../utils/constants";
import { addURLMapping, updateURLMappingById } from "../../../services/api-service";

const URLMappingForm = (props) => {
  let initMode = props.data ? "Edit" : ADMIN_FORM_MODES.add;
  initMode = props?.openDialog === true ? "Edit" : initMode;
  const [showURLMappingForm, setURLMappingFormState] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [mode, setMode] = useState(initMode);

  const validationSchema = useMemo(
    () =>
      yup.object({
        name: yup
          .string()
          .min(2, "Name should be between 2 to 150 alphanumeric characters long")
          .max(150, "Name should be between 2 to 150 alphanumeric characters long")
          .required("Name is required")
          .test('no-emoji', 'Emojis are not allowed', function (value) {
            if (!value) return true;
            return !/\p{Extended_Pictographic}/u.test(value);
          }),
        domainName: yup
          .string()
          .required("Domain Name is required")
          .test('no-emoji', 'Emojis are not allowed', function (value) {
            if (!value) return true;
            return !/\p{Extended_Pictographic}/u.test(value);
          }),
        localIp: yup
          .string()
          .min(2, "Local IP should be between 2 to 100 characters")
          .max(100, "Local IP should be between 2 to 100 characters")
          .matches(/^[^\s]+$/, "Local IP should not contain spaces")
          .required("Local IP is required")
          .test('no-emoji', 'Emojis are not allowed', function (value) {
            if (!value) return true;
            return !/\p{Extended_Pictographic}/u.test(value);
          })
      }),
    []
  );

  const closeURLMappingForm = () => {
    props.onClose();
    setURLMappingFormState(false);
  };

  async function addURLMappingData(data) {
    try {
      addURLMapping(data)
        .then((resp) => {
          if (resp.Status === "Success") {
            showSuccessNotification(`URL Mapping for ${data.name} Created Successfully`);
            props.urlMapping();
            closeURLMappingForm();
          }
          else if (resp.Status === "Fail" && resp.Message && Object.keys(resp.Message).length > 0) {
            let message = "";
            if (resp?.Message === "URL Mapping Already Exists") {
              message = resp.Message
            } else {
              const keys = Object.keys(resp.Message);

              keys.forEach((key) => {
                message += resp.Message[key] + "\n";
              });
            }
            showWarningNotification(message);
          }
          else {
            showWarningNotification(resp.Message.name || resp.Message);
          }
        })
        .catch((e) => {
          showErrorNotification("Error adding URL mapping");
        });
    } catch (e) {
      showErrorNotification("Error in URL mapping adding");
    }
  };

  async function updateURLMappingData(data) {
    try {
      updateURLMappingById(data)
        .then((resp) => {
          if (resp.Status === "Success") {
            closeURLMappingForm();
            props.updateMapping();
            showSuccessNotification(`URL Mapping for ${data.name} Updated Successfully`);
          } else if (resp.Status === "Fail" && resp.Message && Object.keys(resp.Message).length > 0) {
            const keys = Object.keys(resp.Message);
            let message = "";
            keys.forEach((key) => {
              message += resp.Message[key] + "\n";
            });
            showWarningNotification(message);
          }
          else {
            showWarningNotification(resp.Message.name || resp.Message);
          }
        })
        .catch((e) => {
          showErrorNotification("Error updating URL mapping");
        });
    } catch (e) {
      showErrorNotification("Error in URL mapping update");
    }
  };

  const DataForm = (formProps) => {
    let initData = formProps.editData || {
      name: "",
      domainName: "",
      localIp: ""
    };

    return (
      <div className="ozAddURLMappingForm">
        <Formik
          initialValues={initData}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (mode === "Create") {
              addURLMappingData(values);
            }
            else {
              updateURLMappingData(values);
            }
          }}
        >
          {
            (props) => {
              return (
                <div>
                  <form
                    onSubmit={props.handleSubmit}
                    id="urlMappingForm"
                    style={{
                      width: "464px",
                    }}
                  >
                    <Grid container={true} spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <OZInput
                          name="name"
                          placeholder="Enter Name"
                          label="Name *"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <OZInput
                          name="domainName"
                          placeholder="Enter Domain Name"
                          label="Domain Name *"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <OZInput
                          name="localIp"
                          placeholder="Enter Local IP"
                          label="Local IP *"
                        />
                      </Grid>
                    </Grid>
                  </form>
                </div>
              )
            }}
        </Formik>
      </div>
    );
  };

  return (
    <div>
      {mode === ADMIN_FORM_MODES.add ? (
        <OZDialog open={showURLMappingForm} onClose={closeURLMappingForm} title="Add URL Mapping" saveButtonProps={{ form: 'urlMappingForm', type: 'submit' }} mode={mode}>
          <DataForm />
        </OZDialog >
      ) :
        (
          <OZDialog open={showURLMappingForm} onClose={closeURLMappingForm} title="Edit URL Mapping" saveButtonProps={{ form: 'urlMappingForm', type: 'submit' }} mode={mode} hideSaveButton={!(props.editAccess) || false}>
            <DataForm editData={props.data} />
          </OZDialog>
        )
      }
    </div>
  );
};

export default URLMappingForm;